<script>

    import { toast } from 'bulma-toast'
    import { accountStore, accountsStore, modalStore } from '../stores'

    import AccountsService from '../$services/accounts.service'
    import DateMethods from '../$methods/date.methods'

    import Form from '../$components/form.svelte'
    import Date from '../$components/date.svelte'
    import Select from '../$components/select.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import ButtonModal from '../$components/button.modal.svelte'
    import Button from '../$components/button.svelte'
    import Switch from '../$components/switch.svelte'

    let data = {
        status: $accountStore.status,
        limit: $accountStore.limit,
        expired: $accountStore.expired,
        prepayments: $accountStore.prepayments,
    }

    let loading = false
    let updateExpired = false
    let prepayment = {}

    async function updateAccount() {

        loading = true
        const resp = await AccountsService.updateAccount($accountStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        accountStore.set(resp.data)
        accountsStore.replace(resp.data)

        toast({message: 'Cuenta actualizada', type: 'is-success'})
        modalStore.set('account_modal')
    }

    function removePrepayment(index) {
        data.prepayments = data.prepayments.filter((item, i) => i != index)
    }

    function appendPrepayment() {
        
        const obj = {...prepayment}
        
        data.prepayments = [obj, ...data.prepayments]

        prepayment.amount = null
        prepayment.reference = null
    }

</script>

<Form on:submit={updateAccount} { loading } >
    
    <div class="columns">
        <div class="column">
            <Select bind:value={data.status}
                label="Estatus de pago"
                options={[
                    {value: 'pending', text: 'Pendiente'},
                    {value: 'paid', text: 'Pagado'},
                    {value: 'free', text: 'Gratis'},
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.limit} label="Limite" placeholder="Limite del crédito" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="space-top space-bottom">
                <Switch bind:checked={updateExpired} label="Actualizar fecha de expiración" />
            </div>
            {#if updateExpired}
                <Date bind:value={data.expired} label="Fecha de expiración" />
            {/if}
        </div>
    </div>
    {#if data.status === 'paid'}
        <div class="columns">
            <div class="column">
                <Date bind:value={data.payment} label="Fecha de pago" />
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.reference} label="Referencia de pago" placeholder="Referencia de pago" required={data.status === 'paid'} />
            </div>
        </div>
    {/if}
    <br>
    <div class="title is-4">Pagos anticipados</div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={prepayment.amount} label="Monto" placeholder="Monto" required={false} />
        </div>
        <div class="column">
            <InputText bind:value={prepayment.reference} label="Referencia" placeholder="Referencia" required={false} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Date bind:value={prepayment.payment} label="Fecha de pago" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={ appendPrepayment } text="Agregar" icon="plus" />
        </div>
    </div>
    <br>
    <div class="columns">
        <div class="column">
            {#each data.prepayments as prepayment, index}
                <div class="items-space">
                    <div>
                        <small>{ DateMethods.dateTimeLarge(prepayment.payment) }</small>
                        <div class="subtitle is-5"><b>${ prepayment.amount }</b> <small>{ prepayment.reference }</small></div>
                    </div>
                    <span on:click={() => removePrepayment(index)} class="icon pointer"><i class="fas fa-trash"></i></span>
                </div>
                <br>
            {/each}
        </div>
    </div>
    <br>
    <div class="items-end">
        <div class="buttons">
            <ButtonModal modalId="account_modal" text="Cancelar" icon="ban" color="light"/>
            <Button type="submit" text="Guardar" icon="save" color="primary" {loading} />
        </div>
    </div>
</Form>